import React from "react";
import localeText from "../../../../../locale";
import ProductsTable from "./components/ProductsTable";

const Products = (props) => {
  return (
    <div>
      <div className="card p-4 border-300">
        <h3 className="font-medium text-900 my-4">{localeText("product")}</h3>
        <hr />
        <div>
          {props.products.length ? (
            <ProductsTable
              products={props.products}
              totalProducts={props.totalProducts}
              currentPage={props.currentPage}
              onPageChange={props.onPageChange}
            />
          ) : (
            <>Sem caetgorias</>
          )}
        </div>
      </div>
    </div>
  );
};

export default Products
